import type { SystemStyleObject } from "@chakra-ui/react";

const baseStyle: SystemStyleObject = {
  color: "teal.500",
};

export default { baseStyle };
